export const manifest = {
  screens: {
    scr_ao5uyo: { name: "Home", route: "/" },
  },
}
